import React from 'react';
import Icon from '../../../components/AppIcon';

const AssetBalanceCard = ({ asset }) => {
  const isPositive = asset?.change24h >= 0;

  return (
    <div className="card hover:shadow-lg transition-smooth cursor-pointer">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div 
            className="w-12 h-12 rounded-full flex items-center justify-center"
            style={{ backgroundColor: `${asset?.color}15` }}
          >
            <Icon name={asset?.icon} size={24} color={asset?.color} />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground">{asset?.name}</h3>
            <p className="text-xs text-muted-foreground">{asset?.symbol}</p>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <div>
          <p className="text-2xl font-bold text-foreground">
            ${asset?.usdValue?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
          <p className="text-sm text-muted-foreground">
            {asset?.balance?.toLocaleString('en-US', { maximumFractionDigits: 4 })} {asset?.symbol}
          </p>
        </div>

        <div className="flex items-center justify-between pt-2 border-t border-border">
          <div className="flex items-center gap-1">
            <Icon 
              name={isPositive ? 'TrendingUp' : 'TrendingDown'} 
              size={14} 
              className={isPositive ? 'text-success' : 'text-error'}
            />
            <span className={`text-xs font-semibold ${isPositive ? 'text-success' : 'text-error'}`}>
              {isPositive ? '+' : ''}{asset?.change24h?.toFixed(2)}%
            </span>
          </div>
          <span className="text-xs text-muted-foreground">
            {asset?.allocation?.toFixed(1)}% of portfolio
          </span>
        </div>
      </div>
    </div>
  );
};

export default AssetBalanceCard;